import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Route, Switch, Redirect, Link } from 'react-router-dom';

import RedirectToStep from './RedirectToStep';

import * as Steps from '../RegistrationSteps';

import { api } from '../../services';
import { withRouter } from 'react-router-dom';

import { Layout, Alert, Row, Icon, Button } from 'antd';

import { registrationStore } from '../../stores';

import './RegistrationStepsRoute.css';

import K from '../../services/constants';

const savePdf = (function() {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  return function(data, fileName) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

@withRouter
@inject('registrationStore', 'translationsStore', 'profileStore')
@observer
export default class RegistrationStepsRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [0, 1, 2, 3, 4, 5, 6]
    };

    this.props.registrationStore.reloadHeartbeat();
  }

  componentWillUnmount() {
    this.props.registrationStore.setSession();
  }

  getFirstUppercase(word = '') {
    return word.split(' ').reduce((w1, w2) => {
      w2 = w2.trim().toLowerCase();
      switch (w2.length) {
        case 0:
          w2 = '';
          break;
        case 1:
          w1.lenght > 0 && (w2 = `${w2[0].toUpperCase()}`);
          break;
        default:
          w2 = `${w2[0].toUpperCase()}${w2.slice(1)}`;
      }
      return [w1, w2].join(' ');
    }, '');
  }

  /**
   * donwload documento di adesione e collaudo
   */
  onClickDownloadAdesioneHandler(e) {
    const { user } = this.props.registrationStore;
    this.setState({ inProgress: true });
    let action = 'create agreement';

    api({ action }, user._id, user.assets[0].imei)
      .then(result => {
        this.setState({ inProgress: false });
        return savePdf(result, `adesione_${user.lastname || user.ragsoc}.pdf`);
      })
      .catch(() => {
        this.setState({ inProgress: false });
      });
  }

  availableFiles = () => {
    const {
      translationsStore: { current: t },
      profileStore
    } = this.props;

    return (
      <div className="availableFiles">
        <strong>{t['shared']['lblDownloadAvailable']}:</strong>
        &nbsp;
        <strong className={profileStore.profile.personalcode}>
          <Link to={`${K.POLICY_BASE_URL}${this.props.registrationStore.documentName}`} target="_blank">
            {t['registration_3']['btnGeneralModule']} <Icon type="download" />
          </Link>
        </strong>{' '}
        e &nbsp;
        <strong>
          <a onClick={this.onClickDownloadAdesioneHandler.bind(this)}>
            {this.props.registrationStore.user.installationByInstaller ? t['registration_3']['btnOnlyAgreementModule'] : t['registration_3']['btnAgreementModule']} <Icon type={this.state.inProgress ? 'loading' : 'download'} />
          </a>
        </strong>
      </div>
    );
  };

  previous() {
    switch (this.props.registrationStore.position) {
      case 3:
        this.props.history.push('/registration/step_1');
        break;
      case 4:
        this.props.history.push('/registration/step_3');
        break;
      case 5:
      case 6:
        if (this.props.registrationStore.isPaymentExternal) {
          this.props.history.push('/registration/step_3');
        } else {
          this.props.history.push('/registration/step_4');
        }

        break;
      // no default
    }
  }

  current() {
    this.props.history.push(`/registration/step_${Math.floor(this.props.registrationStore.status)}`);
  }

  previousTitle() {
    switch (this.props.registrationStore.position) {
      case 3:
        return this.props.registrationStore.getPositionTitle(2);
      case 4:
        return this.props.registrationStore.getPositionTitle(3);
      case 5:
      case 6:
        if (this.props.registrationStore.isPaymentExternal) {
          return this.props.registrationStore.getPositionTitle(3);
        }
        return this.props.registrationStore.getPositionTitle(4);
      // no default
    }
  }

  currentTitle() {
    switch (this.props.registrationStore.status) {
      case 3:
      case 4:
      case 5:
        return this.props.registrationStore.getPositionTitle(this.props.registrationStore.status);
      case 5.1:
      case 5.2:
        return this.props.registrationStore.getPositionTitle(6);
      // no default
    }
  }

  isLastAvailablePosition() {
    switch (this.props.registrationStore.status) {
      case 3:
      case 4:
      case 5:
        return this.props.registrationStore.position === this.props.registrationStore.status;
      case 5.1:
      case 5.2:
        return this.props.registrationStore.position >= 5;
      default:
        return true;
    }
  }

  render() {
    const {
      translationsStore: { current: t }
    } = this.props;
    return (
      <Layout className="RegistrationStepsRoute">
        <Layout.Header className="RegistrationStepsHeader">
          <div className="alerts">
            {this.props.registrationStore.heartbeat.status === -1 && (
              <Row style={{ marginTop: '5px' }}>
                <Alert type="warning" showIcon message={t['shared']['lblDeviceNotInstalled']} />
              </Row>
            )}
            {this.props.registrationStore.signatureMethod !== 'digital' && this.props.registrationStore.status >= 4 && this.props.registrationStore.status <= 5.2 && (
              <Row style={{ marginTop: '5px' }}>
                <Alert type="info" showIcon message={this.availableFiles()} />
              </Row>
            )}
          </div>
          <Row className="steps">
            <Steps.ProgressSteps />
          </Row>
          <Row className="stepsTitle">
            {this.props.registrationStore.status > 2 && this.props.registrationStore.status < 6 && this.props.registrationStore.position > 2 && (
              <div className="back">
                <Button type="primary" onClick={this.previous.bind(this)} icon="left">
                  {this.previousTitle()}
                </Button>
              </div>
            )}
            <div>{this.getFirstUppercase(this.props.registrationStore.getPositionTitle())}</div>

            {!this.isLastAvailablePosition() && (
              <div className="current">
                <Button type="primary" onClick={this.current.bind(this)}>
                  {this.currentTitle()} *<Icon type="right" />
                </Button>
                <span>{t['shared']['lblNoSaving']} </span>
              </div>
            )}
          </Row>
        </Layout.Header>
        <Layout.Content>
          <Switch>
            <Redirect from="/registration" exact to="/registration/step_0" />

            {this.state.steps.map(s => (
              <Route
                key={s + '' + registrationStore.session}
                path={'/registration/step_' + s}
                render={props => {
                  Object.assign(props, { session: registrationStore.session });
                  return React.createElement(Steps[`Step_${s}`], props);
                }}
              />
            ))}

            <Route path="/registration/:session/" render={props => <RedirectToStep session={props.match.params.session} />} />
          </Switch>
        </Layout.Content>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationStepsRoute/RegistrationStepsRoute.js